import {globalAnimation} from "./globalAnimation";

export function startAnimation() {
    /*let
      body = $('body'),
      slider = $('.banner-slider'),
      sliderFunc;*/
/*
    if (slider.length) {
        sliderFunc = mainBannerSlider();
    }*/

   /* if ($('.preloader').length) {
        body.on('preloaderComplete', function () {
            body.removeClass('has-preloader');

            if (slider.length) {
                sliderFunc.sliderPlay();
            }

            globalAnimation().init();
        });

        preloader();

    } else {
        globalAnimation();

        if (slider.length) {
            sliderFunc.sliderPlay();
        }
    }*/


  globalAnimation();
}



// WEBPACK FOOTER //
// ./assets/js/modules/startAnimation.js